import React from 'react';

export const ChevronLeftGray400Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_4652_7213"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="4"
        width="7"
        height="12"
      >
        <path
          d="M13.5832 14.4165C13.9165 14.7498 13.9165 15.2498 13.5832 15.5832C13.4165 15.7498 13.2498 15.8332 12.9998 15.8332C12.7498 15.8332 12.5832 15.7498 12.4165 15.5832L7.4165 10.5832C7.08317 10.2498 7.08317 9.74984 7.4165 9.4165L12.4165 4.4165C12.7498 4.08317 13.2498 4.08317 13.5832 4.4165C13.9165 4.74984 13.9165 5.24984 13.5832 5.58317L9.1665 9.99984L13.5832 14.4165Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4652_7213)">
        <rect width="20" height="20" transform="translate(0.5)" fill="#555555" />
        <rect x="0.5" width="20" height="20" fill="#888888" />
      </g>
    </svg>
  );
};
